import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-functions',
    templateUrl: './functions.component.html',
    styleUrls: ['./functions.component.scss']
})
export class FunctionsComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
